import * as R from 'ramda';

import { createSelector } from 'reselect';

export default createSelector(
  R.path(['routeParams', 'receptionId']),

  R.identity,
);
